import React, { Component } from "react";
import { CommonConstList } from "./CodeList";
import "./stylesheet/Modal.css";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalType: CommonConstList.Modal.TYPE_INPUT,
      title: "제목",
      message: "로그아웃 하시겠습니까?",
      placeholder: "Input your message here",
      validation: true,
      show: false,
    };
    this.strInput = "";
    this.callback = null;
    this.inputBox = React.createRef();
    this.ButtonType = {
      TYPE_OK: "TYPE_OK",
      TYPE_CANCEL: "TYPE_CANCEL",
    };
  }

  buttonClicked = (e) => {
    //let btnType = e.target.dataset.btntype;
    let btnType = e;
    this.setState({
      show: false,
      validation: true,
    });
    //console.log("this.callback", this.callback);
    switch (btnType) {
      case this.ButtonType.TYPE_OK:
        //입력값이 필요한 경우
        if (this.state.modalType === CommonConstList.Modal.TYPE_INPUT) {
          if (this.strInput.trim() === "") {
            this.setState({ validation: false });
            return;
          } else {
            if (this.callback) {
              this.callback(true, this.strInput);
            }
          }
        } else {
          if (this.callback) {
            this.callback(true);
          }
        }
        break;
      case this.ButtonType.TYPE_CANCEL:
        if (this.callback) {
          this.callback(false);
        }
        break;
    }
  };

  openModal = (type, title, message, placeholder = "", callback) => {
    this.setState({
      title: title,
      message: message,
      placeholder: placeholder,
      modalType: type,
      show: true,
    });
    this.callback = callback;
    if (this.inputBox.current) this.inputBox.current.value = "";
  };

  alert = (message, callback) => {
    this.setState({
      title: <i className="fa-solid fa-bell text-freiscop"></i>,
      message: message,
      placeholder: "",
      modalType: CommonConstList.Modal.TYPE_ALERT,
      show: true,
    });
    this.callback = callback;
    if (this.inputBox.current) this.inputBox.current.value = "";
  };

  confirm = (message, callback) => {
    this.setState({
      title: <i className="fa-regular fa-circle-check text-freiscop"></i>,
      message: message,
      placeholder: "",
      modalType: CommonConstList.Modal.TYPE_CONFIRM,
      show: true,
    });
    this.callback = callback;
    if (this.inputBox.current) this.inputBox.current.value = "";
  };

  closeModal = () => {
    this.setState({
      show: false,
    });
  };

  strInputChanged = (e) => {
    //this.setState({ show: true });
    this.strInput = e.target.value.trim();
  };

  inputRender = () => {
    return (
      <>
        <div className="commonModalInputTextWrap">
          <input
            name={"ModalInput"}
            id={"ModalInput"}
            className="commonModalInput"
            type={"text"}
            placeholder={this.state.placeholder}
            maxLength={50}
            onChange={this.strInputChanged.bind(this)}
            ref={this.inputBox}
            autoSave="off"
            autoComplete="off"
          />
          <p className="commonModalInputText">
            {!this.state.validation && "내용을 입력해 주세요."}
          </p>
        </div>
      </>
    );
  };
  render() {
    return (
      <>
        <div
          className="commonModal modal-content default_modal_animation rounded-lg"
          style={{
            display: this.state.show ? "" : "none",
            maxWidth: 400,
          }}
        >
          <div className="modal-header border-0">
            <p className="display-4 mb-0 flex-grow-1 text-center">
              {this.state.title}
            </p>
            <i
              className="fas fa-times"
              onClick={() => this.buttonClicked(this.ButtonType.TYPE_CANCEL)}
            />
          </div>
          <div className="px-3">
            <div className="border-top border-bottom border-2 py-3 text-center">
              <p className="h6 mb-0" style={{ whiteSpace: "break-spaces" }}>
                {this.state.message}
              </p>
            </div>
          </div>

          {this.state.modalType === CommonConstList.Modal.TYPE_INPUT &&
            this.inputRender()}
          <div className="modal-footer border-0">
            {this.state.modalType !== CommonConstList.Modal.TYPE_ALERT && (
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => this.buttonClicked(this.ButtonType.TYPE_CANCEL)}
                data-btntype={this.ButtonType.TYPE_CANCEL}
              >
                <i className="fa fa-times mr-2" /> 취소
              </button>
            )}
            <button
              className="btn btn-sm btn-primary ml-2"
              onClick={() => this.buttonClicked(this.ButtonType.TYPE_OK)}
            >
              <i className="fa fa-check mr-2" /> 확인
            </button>
          </div>
        </div>
        <div
          className="commonModal_layer"
          style={{
            display: this.state.show ? "" : "none",
          }}
        />
      </>
    );
  }
}

export default Modal;
/*

const Modal = ({ cb }) => {
  let [title, setTitle] = useState("제목");
  let [message, setMessage] = useState("로그아웃 하시겠습니까?");
  let [placeholder, setPlaceholder] = useState("Input your message here");
  let [validation, setValidation] = useState(true);
  let [strInput, setStrInput] = useState("");
  let [show, setShow] = useState(false);
  let [modalType, setModalType] = useState(CommonConstList.Modal.TYPE_INPUT);

  let callback = cb;

  let socket = new BuddibleSocket();
  const ButtonType = {
    TYPE_OK: "TYPE_OK",
    TYPE_CANCEL: "TYPE_CANCEL",
  };

  useEffect(() => {
    socket.waitingForConnect("InitCodeList", () => {});
  }, []);

  useEffect(() => {
    console.log("strInput changed", strInput);
  }, [strInput]);

  const buttonClicked = (e) => {
    let btnType = e.target.dataset.btnType;

    switch (btnType) {
      case ButtonType.TYPE_OK:
        //입력값이 필요한 경우

        if (modalType === CommonConstList.Modal.TYPE_INPUT) {
          if (callback) {
            callback(true, strInput);
          }
        } else {
          callback(true);
        }

        break;
      case ButtonType.TYPE_CANCEL:
        if (callback) {
          callback(false);
        }
        break;
    }
  };
  const openModal = () => {
    setShow(true);
    console.log("openModal");
  };
  const strInputChanged = (e) => {
    setStrInput(e.target.value);
  };

  return (
    <>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          background: "gray",
          display: show ? "" : "none",
        }}
      >
        <div style={{ width: "50vw", height: "50vh", background: "white" }}>
          <h4>{title}</h4>
          <p>{message}</p>
          {modalType === CommonConstList.Modal.TYPE_INPUT && (
            <>
              <input
                type={"text"}
                placeholder={placeholder}
                maxLength={50}
                onChange={strInputChanged.bind(this)}
              />
              <p style={{ color: "red" }}>
                {!validation && "내용을 입력해 주세요."}
              </p>
            </>
          )}
          <button
            onClick={buttonClicked.bind(this)}
            data-btnType={ButtonType.TYPE_OK}
          >
            확인
          </button>
          <button
            onClick={buttonClicked.bind(this)}
            data-btnType={ButtonType.TYPE_CANCEL}
          >
            취소
          </button>
        </div>
      </div>
    </>
  );
};

export default Modal;
*/
